import React from 'react';
import PropTypes from 'prop-types';

import { Select } from 'components/ui/select';

export default class SelectFilter extends React.Component {
  static propTypes = {
    autoWidth: PropTypes.bool,
    name: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    onChange: PropTypes.func.isRequired,
  };

  render() {
    return (
      <Select
        menuPosition="fixed"
        styles={{ menuPortal: base => ({ ...base, zIndex: 1080 }) }}
        {...this.props}
      />
    );
  }
}
